import { Injectable,  } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { LoaderService } from '../../common/services/loader.service';
import { OrganizationService } from '../services/organization.service';
import { AuthService } from '../../services/auth.service';
import { EMPTY, Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';


@Injectable()
export class OrganizationResolver  {
    constructor(
        public authService: AuthService,
        public dataService: OrganizationService,
        public loaderService: LoaderService,
        private router: Router ) {
    }

    resolve(route: ActivatedRouteSnapshot) {
        this.loaderService.toggleLoader(true);
        let obs: Observable<any>;  
        let orgId = route.paramMap.get('organizationId');
        if (!orgId) {
            orgId = this.authService.User.organizationId;
        }
        obs = this.dataService.getOrganization(orgId);

        return obs.pipe(
            catchError((error) => {
                console.error(error);
                this.loaderService.toggleLoader(false);
                this.router.navigate(["/home"]);
                return EMPTY;
            }),
            tap((result) => {
                this.loaderService.toggleLoader(false);
        }));
    }
}